<ds-mobile-page-title></ds-mobile-page-title>
@if (loading || !!(aiBuilderService.pageLoading|async)) {
  <db-loading-screen class="sl-enable-builder-progress" [pageBlocker]="true"></db-loading-screen>
} @else {
  <db-ai-builder-disabled *ngIf="(!builderPlugin?.active || !elementorPlugin?.active) && !loading" (onEnable)="installAndActivate()"></db-ai-builder-disabled>
  <db-ai-builder-pages
    [canGenerateWebsites]="canGenerateWebsites"
    *ngIf="builderPlugin?.active && elementorPlugin?.active
  && ((onboardingPassed || seenNewAiFlow || onboardingFinished || demoUser) || (!(onboardingPassed || seenNewAiFlow || onboardingFinished) && !userSubscription?.plan?.services?.ai_builder))"
    [pagesLimit]="pagesLimit"  (onRecreate)="createPageDialog($event)" (onRegenerate)="regenerateDialog($event)"></db-ai-builder-pages>
  <db-recreate-first-time *ngIf="userSubscription?.plan?.services?.ai_builder && !demoUser && !onboardingPassed && !seenNewAiFlow && !onboardingFinished && builderPlugin?.active && elementorPlugin?.active"
                          [websiteId]="website?.id" [website]="website" [builderPlugin]="builderPlugin" [elementorPlugin]="elementorPlugin" [user]="user" [forRecreateFirstTime]="true"></db-recreate-first-time>
}


